export enum CollectionConstant {
    NAME_MAX_LENGTH = 100,
    CODE_MAX_LENGTH = 100,
    DESCRIPTION_MAX_LENGTH = 100,
}
